import { memo } from 'react';

import { CDN_BASE_URL } from 'settings';

import { Image } from './styles';

const RocketImage: React.FC = () => {
  return <Image src={`${CDN_BASE_URL}/rocketImage.svg`} />;
};

export default memo(RocketImage);
